export function get(companyId)
{
    return axios.get(route('api.manage.companies.paidSubscriptions',  { company: companyId }))
        .then(({data}) => data);
}